<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('productNonMovingStock.pageTitle') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('productNonMovingStock.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-3">
            <div class="ts-flex ts-justify-between">
              <label class="col-form-label required">{{
                $t('productNonMovingStock.dateRange')
              }}</label>
            </div>
            <a-range-picker style="width:100%;" v-model="model.date_range" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
              :allowClear="false" />
            <div class="validate" v-if="errors.has('date_range')">
              {{ errors.first('date_range') }}
            </div>
          </div>
          <div class="col-md-3">
            <label class="col-form-label">{{
              $t('productNonMovingStock.branchName')
            }}</label>
            <a-select style="width: 100%; font-size: 15px" mode="multiple" placeholder="All" :max-tag-count="1"
              :filterOption="(input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
                " v-model="model.branch_id" :options="branchs"></a-select>
          </div>
          <div class="col-md-3">
            <label class="col-form-label">{{
              $t('productNonMovingStock.wareHouse')
            }}</label>
            <a-select v-model="model.location_id" mode="multiple" showSearch :max-tag-count="1" :filterOption="(input, option) =>
              option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
              " :options="warehouse" :placeholder="$t('all')" class="ts-w-full"></a-select>
          </div>
          <div class="col-md-3">
            <label class="col-form-label">{{ $t('productNonMovingStock.category') }}</label>
            <a-select v-model="model.category_id" :options="category" mode="multiple" showSearch :max-tag-count="1"
              :filterOption="(input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
                " class="ts-w-full" :placeholder="$t('all')"></a-select>
            <div class="validate" v-if="errors.has('category_id')">
              {{ errors.first('category_id') }}
            </div>
          </div>
          <div class="col-md-3">
            <label class="col-form-label">{{ $t('productNonMovingStock.group') }}</label>
            <a-select v-model="model.pro_group_id" :options="productGroup" mode="multiple" showSearch :max-tag-count="1"
              :filterOption="(input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
                " class="ts-w-full" :placeholder="$t('all')"></a-select>
            <div class="validate" v-if="errors.has('category_id')">
              {{ errors.first('category_id') }}
            </div>
          </div>
          <div class="col-md-3">
            <label class="col-form-label">{{ $t('productNonMovingStock.product') }}</label>
            <a-select v-model="model.product_id" :options="products" :max-tag-count="1" mode="multiple"
              @search="handleSearchProduct" :loading="product_searching" showSearch :filterOption="(input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
                " class="ts-w-full" :placeholder="$t('all')"></a-select>
            <div class="validate" v-if="errors.has('category_id')">
              {{ errors.first('category_id') }}
            </div>
          </div>
          <div class="col-md-3">
            <label class="col-form-label">{{ $t('search') }}</label>
            <Input search v-model="search" :placeholder="$t('search')" />
          </div>
          <div class="col-md-3">
            <label class="col-form-label ts-w-full">{{ $t('excel') }}</label>
            <ts-button class="ts-w-20 ts-h-8" outline color="success" @click.prevent="exportExcel"
              :waiting="exporting"><i class="fas fa-file-excel"></i> {{ $t('excel') }}</ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <Tabs v-model="model.type">
        <TabPane label="Summary By Group" name="summary" icon="md-list">
          <ts-loading-banner :loading="loading">
            <Summary :summary="summary" />
          </ts-loading-banner>
        </TabPane>
        <TabPane label="Detail By Items" name="detail" icon="md-apps">
          <ts-loading-banner :loading="loading">
            <Detail :summary="summary" />
          </ts-loading-banner>
        </TabPane>
      </Tabs>
      <div class="d-flex justify-content-end p-15">
        <ts-i-pagination v-model="pagination" @navigate="fetchData"></ts-i-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import Summary from './components/summary.vue'
import Detail from './components/detail.vue'
import { debounce } from 'lodash'
import { includes } from 'lodash'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'
export default {
  name: 'ProductNonMovingStock',
  components: {
    Summary,
    Detail
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      exporting: false,
      product_searching: false,
      summary: {},
      model: {
        date_range: [
          moment()
            .startOf('month')
            .format('DD-MM-YYYY'),
          moment()
            .endOf('month')
            .format('DD-MM-YYYY')
        ],
        category_id: [],
        branch_id: [],
        location_id: [],
        pro_group_id: [],
        product_id: [],
        type: 'summary'
      }
    }
  },
  computed: {
    ...mapState('report/productNonMovingStock', ['pagination', 'formViewDatas']),
    search: {
      get() {
        return this.$store.state.report.productNonMovingStock.search
      },
      set(newValue) {
        this.$store.commit('report/productNonMovingStock/SET_SEARCH', newValue)
        this.$store.commit('report/productNonMovingStock/RESET_CURRENT_PAGE')
      }
    },
    branchs() {
      if (this.formViewDatas['branchs']) {
        return this.formViewDatas['branchs'].map(el => ({
          value: el.branch_id,
          label: el.branch_name_en
        }))
      }
      return []
    },
    warehouse() {
      if (this.formViewDatas['warehouse']) {
        if (this.model.branch_id.length > 0) {
          return this.formViewDatas['warehouse']
            .filter(i => includes(this.model.branch_id, i.branch_id))
            .map(el => ({
              value: el.location_id,
              label: el.location_name_en
            }))
        }
        return this.formViewDatas['warehouse'].map(el => ({
          value: el.location_id,
          label: el.location_name_en
        }))
      }
      return []
    },
    category() {
      if (this.formViewDatas['category']) {
        return this.formViewDatas['category'].map(el => ({
          value: el.category_id,
          label: el.category_name_en
        }))
      }
      return []
    },
    productGroup() {
      if (this.formViewDatas['productGroup']) {
        if (this.model.category_id.length > 0) {
          return this.formViewDatas['productGroup']
            .filter(i => includes(this.model.category_id, i.category_id))
            .map(el => ({
              value: el.pro_group_id,
              label: el.pro_group_name_en
            }))
        }
        return this.formViewDatas['productGroup'].map(el => ({
          value: el.pro_group_id,
          label: el.pro_group_name_en
        }))
      }
      return []
    },
    products() {
      if (this.formViewDatas['products']) {
        if (
          this.model.category_id.length > 0 ||
          this.model.pro_group_id.length > 0
        ) {
          return this.formViewDatas['products'].map(el => ({
            value: el.product_id,
            label: el.barcode + '|' + el.product_name_en
          }))
        }
        return this.formViewDatas['products'].map(el => ({
          value: el.product_id,
          label: el.barcode + '|' + el.product_name_en
        }))
      }
    }
  },
  methods: {
    ...mapActions('report/productNonMovingStock', ['getFormViewModel']),
    async getPreData({ params, index }) {
      this.loading = true
      await this.getFormViewModel({ index: index, params: params })
      this.loading = false
    },
    async fetchData(attributes) {
      this.loading = true
      await this.$store
        .dispatch('report/productNonMovingStock/fetch', Object.assign(
          this.model,
          attributes
        ))
        .then((response) => {
          this.summary = response.summary
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.errors = new Errors(error.errors)
          this.notice({ type: 'error', text: error.message })
        })
    },
    exportExcel() {
      this.errors = new Errors()
      this.exporting = true

      this.$store
        .dispatch('report/productNonMovingStock/exportExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.notice({ type: 'error', text: error.message })
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    handleSearchProduct: debounce(async function (value) {
      this.product_searching = true
      await this.getFormViewModel({
        index: 'products',
        params: {
          fnName: 'products',
          search_product: value,
          product_id: this.model.product_id
        }
      })
      this.product_searching = false
    }, 800),
    notice(not) {
      this.$Notice[not.type]({
        title: 'Product Non Moving Stock',
        desc: not.text
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
    model: {
      handler(value) {
        this.fetchData()
      },
      deep: true
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPreData({
        params: {},
        index: undefined
      })
      vm.fetchData()
    })
  }
}
</script>
<style scoped>
.text-left {
  text-align: left;
}
</style>
